import React from "react";
import "./HomeHero.scss";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Image } from "react-bootstrap";
import ShipShore from "../ShipShore/ShipShore"; 
import Slider from "react-slick"; // Import Slider from react-slick
import s1 from "../../../Assets/slide_1.png";
import s2 from "../../../Assets/slide_2.png";
import s3 from "../../../Assets/slide_3.png";
import s4 from "../../../Assets/slide_4.png";
import s5 from "../../../Assets/slide_5.png";
import s6 from "../../../Assets/slide_6.png";

const HomeHero = () => {
  const navigate = useNavigate();

 // Updated Slick settings
const settings = {
  dots: true, // Show navigation dots
  infinite: true, // Loop through slides
  speed: 500, // Animation speed
  slidesToShow: 1, // Show only one slide at a time
  slidesToScroll: 1, // Scroll one slide at a time
  autoplay: true, // Enable auto rotation
  autoplaySpeed: 3000, // Set rotation interval to 3 seconds
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};


  return (
    <div className="hero-wrapper">
      <Container className="hero-container">
          <ShipShore />
          
          {/* Slick Slider */}
          {/* <div className="carousel-container">
            <Slider {...settings}>
              <div className="carousel-item-wrapper">
                <img src={s1} alt="Claw Machine" className="carousel-image" />
              </div>
              <div className="carousel-item-wrapper">
                <img src={s2} alt="Stuffy Dog" className="carousel-image" />
              </div>
              <div className="carousel-item-wrapper">
                <img src={s3} alt="Bear" className="carousel-image" />
              </div>
              <div className="carousel-item-wrapper">
                <img src={s4} alt="Claw Bear" className="carousel-image" />
              </div>
              <div className="carousel-item-wrapper">
                <img src={s5} alt="Skill" className="carousel-image" />
              </div>
              <div className="carousel-item-wrapper">
                <img src={s6} alt="Skill" className="carousel-image" />
              </div>
            </Slider>
          </div> */}

          {/* Hero Overlay */}
          {/* <div className="hero-overlay large-screen">
            <h1>Welcome to Funda Sourcing</h1>
            <p>
            Your trusted partner in sourcing high-quality home supplies, eco-friendly products, and pet toys from China and Vietnam. At Funda Sourcing, we specialize in connecting brands with reliable manufacturers to bring sustainable and innovative products to life.
            </p>
            <div className="buttonRootDiv">
              <Button
                className="hear-demo-button"
                onClick={() => navigate("/about")}
              >
                ABOUT US
              </Button>
              <Button
                variant="outline"
                className="try-now-button"
                onClick={() => navigate("/contact")}
              >
                CONTACT
              </Button>
            </div>
          </div> */}
      </Container>
    </div>
  );
};

export default HomeHero;
